<template>
    <div id="player">


    </div>
</template>

<script>
import { timestampToTime } from "@/utils/date";
import {serviceWebUrl} from "@/utils/global";
export default {
    name: "homeOfficeLink",
    components: {},
    data() {
        return {
            timestampToTime,
            isLogin:this.$storage.get('isLogin'),
            videoId:'',
            vodPlayerJs: 'https://player.polyv.net/resp/vod-player/latest/player.js',
        };
    },
    created() {},
    mounted() {
        this.videoId = this.$route.query.vid;
        this.viewVideo();
    },
    computed: {},
    methods: {
        viewVideo(){
            if (this.isLogin){
                setTimeout(() => {
                    this.loadPlayerScript(this.loadPlayer);
                })
            }else {
                this.$confirm("您查看的内容需要登录，是否继续？", "温馨提示", {
                    confirmButtonText: "去登录",
                    cancelButtonText: "取消",
                    type: "success"
                }).then(() => {
                    this.userToLogin()
                }).catch(()=>{
                    this.activePath = this.lastActivePath;
                })
            }

        },
        loadPlayerScript(callback) {
            if (!window.polyvPlayer) {
                const myScript = document.createElement('script');
                myScript.setAttribute('src', this.vodPlayerJs);
                myScript.onload = callback;
                document.body.appendChild(myScript);
            } else {
                callback();
            }
        },
        loadPlayer() {
            const polyvPlayer = window.polyvPlayer;
            this.player = polyvPlayer({
                wrap: '#player',
                // width: this.videoWidth,
                // height: this.videoHeight,
                vid: this.videoId,
            });
        },
        destroyed() {
            if (this.player) {
                this.player.destroy();
            }
        },

        userToLogin(){
            //参数传递
            const link = serviceWebUrl+'/lyedu/officeLink?vid='+this.videoId
            this.$router.push({
                path: '/login',
                query: {
                    callback: link,
                }
            });
            // let routeUrl = this.$router.resolve({
            //     path: "/login",
            //     query: {
            //         callback: link,
            //     }
            // });
            // window.open(routeUrl.href, '_blank')
        },
    },

}

</script>

<style scoped>
.news-box{
    height:100vh;
    overflow: auto;
    scrollbar-width: none;
}

.news-box::-webkit-scrollbar {
    display: none;
}
</style>